import React from "react";
import { FrontSpacing } from "../../../../models/FrontSpacing";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { FrontIcon, TIcon } from "../FrontIcon/FrontIcon";

export type TFormPrimaryButtonProps = {
    label: string | JSX.Element;
    icon?: TIcon;
    isDisabled?: boolean;
    isLoading?: boolean;
    iconPosition?: "left" | "right";
    colourVariant?: "primary" | "positive-apple";
    onClick: () => void;
};

export const FrontFormPrimaryButton = (props: React.PropsWithChildren<TFormPrimaryButtonProps>): JSX.Element => {
    const iconPosition = props.iconPosition || "left";

    const colourVariant = props.colourVariant || "primary";

    const interactionLocked = props.isDisabled === true || props.isLoading === true;

    return (
        <div
            className={`
                front-form-primary-button
                front-form-primary-button--${interactionLocked ? "disabled" : `enabled-${colourVariant}`}
            `}
            onClick={() => {
                if (!interactionLocked) {
                    props.onClick();
                }
            }}
        >
            <SpacingRow
                spacing={FrontSpacing.SMALL_3}
                justifyContent="center"
            >
                {props.isLoading &&
                    <div className="front-form-primary-button__spinner" aria-label="Loading" />
                }

                {!props.isLoading && props.icon && iconPosition === "left" &&
                    <FrontIcon
                        iconName={props.icon}
                        colour={"neutral-18"}
                        size="small"
                    />
                }

                {!props.isLoading &&
                    <span>
                        {props.label}
                    </span>
                }

                {!props.isLoading && props.icon && iconPosition === "right" &&
                    <FrontIcon
                        iconName={props.icon}
                        colour={"neutral-18"}
                        size="small"
                    />
                }
            </SpacingRow>
        </div>
    );
};
